<template>
	<v-card flat max-width="950px" class="mx-auto transparent">
        <HeadRoot 
            title="Videos"
            :length="0"
            btn_txt=""
            btn_to="" />
        
        <template v-if="loaded">
            <div class="display-1 font-weight-light mt-6" :style="{color: course.color}">{{course.categoryTitle}} Videos</div>
            <div class="mt-1">
                <v-btn text class="grey--text text--darken-1" @click="$router.push('/videos')">
                    <v-icon size="14px" color="grey darken-1" class="mr-3">fa-angle-left</v-icon>
                    Back to List
                </v-btn>
            </div>

            <v-tabs v-model="tab" background-color="#FDFDFD" class="mb-6">
                <v-tab class="font-weight-regular black--text">Information</v-tab>
                <v-tab class="font-weight-regular black--text">Videos</v-tab>

                <v-tab-item>
                    <Information :course="course" @watch="tab=1" />
                </v-tab-item>

                <v-tab-item>
                    <PlayList :course="course" />
                </v-tab-item>
            </v-tabs>
        </template>

        <SendingLoader v-if="!loaded" />
	</v-card>
</template>

<script>
import _ from 'lodash'
import Helpers from '@/services/helpers'
import Videos from '@/firebase/videos'
import Information from '@/components/videos/Information'
import PlayList from '@/components/videos/PlayList'

export default {
    data: () => ({
        loaded: false,
        tab: 0,
        categories: [],
        course: null
    }),
    components: {
        Information,
        PlayList
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            Videos.getCoursesCategories()
                    .then(response => {
                        if (response.status === true) {
                            this.categories = Helpers.formatItems(response.query);
                            this.getCourse();
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        getCourse() {
            Videos.get(this.$route.params.id)
                    .then(response => {
                        if (response.status === true) {
                            this.course = response.doc.data();
                            this.course.id = response.doc.id;
                            this.setCategoryInfo();
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        },
        setCategoryInfo() {
            let tempo = this.categories.find(item => {return item.id == this.course.category});
            this.course.categoryTitle = tempo.title;
            this.course.color = tempo.color;
            this.course.short = tempo.short;
        }
    }
}
</script>